import React from "react";
import classnames from "classnames";
import * as PageActions from "../actions/PageActions";

const PageContainer = (props) => {
	var classes = classnames({
		"page-container": true,
		"leftnav-hide": props.hideLeftNav,
		"header-hide": props.hideHeader
	});

	return (<div className={classes}>{props.children}</div>);
};

export default PageContainer;



/** WEBPACK FOOTER **
 ** ./src/scripts/components/PageContainer.jsx
 **/